import React from 'react';
import img1 from '../../assets/images/icon/icon1.png';
import img2 from '../../assets/images/icon/icon2.png';
import img3 from '../../assets/images/icon/icon3.png';

const steps = [
  {
    id: 1,
    icon: img1,
    title: 'Choose Your Plan',
    desc: 'Select from our AI-driven trading plans tailored for every level.'
  },
  {
    id: 2,
    icon: img2,
    title: 'Activate Your Account',
    desc: 'Quick onboarding with secure setup.'
  },
  {
    id: 3,
    icon: img3,
    title: 'Let the Bot Trade',
    desc: 'Sit back as PipPlus Algo handles the market for you.'
  }
];

function Steps() {
  return (
    <section className="create">
      <div className="container">
        <div className="block-text center">
          <h6 className="sub-heading"><span>How It Works</span></h6>
          <h3 className="heading">Start Your Trading Journey with PipPlus</h3>
        </div>
        <div className="row">
          <div className="col-xl-6 col-md-12">
            <div className="create__content">
              {steps.map((item, index) => (
                <div key={item.id} className="create-box">
                  <div className="step">Step {index + 1}</div>
                  <div className="icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div className="content">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-xl-6 col-md-12">
            <div className="create__image">
              <div className="image">
                <img src="/assets/images/layouts/banner-05.png" alt="pipplus-step" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Steps;
